function Footer() {

    return (
        <footer>
            <p>Built with React - <a href="https://www.freepik.com/free-vector/cute-astronaut-flying-space-cartoon-icon-illustration_12681140.htm#page=3&query=astronaut&position=40&from_view=keyword" target="_blank" rel="noreferrer">Astronaut image by catalyststuff</a> on Freepik</p>
        </footer>
    );
}

export default Footer;